import type { AiChatMessage } from "@productlane/lib/src/ai"

const CLAUDE_CODE_PROMPT_MAX = 4800
const PRODUCTLANE_MCP_ENDPOINT = "https://productlane.com/api/mcp"
const OMITTED_MARKER = "[...earlier turns omitted...]"

function stripHtml(html: string): string {
	return html
		.replace(/<[^>]*>/g, " ")
		.replace(/\s+/g, " ")
		.trim()
}

export function buildContinueInClaudeLink(input: {
	messages: AiChatMessage[]
	threadId: string
	threadTitle: string | null
}): { deepLink: string; prompt: string } {
	const { messages, threadId, threadTitle } = input
	const threadUrl = `${window.location.origin}/threads/${threadId}`

	const header = [
		"You are continuing a Productlane support-agent conversation about a customer thread.",
		"",
		`Connect the Productlane MCP server at ${PRODUCTLANE_MCP_ENDPOINT} so you can keep acting on this thread (read it, reply, file issues, update status).`,
		"",
		`Thread: ${threadTitle?.trim() || "(untitled)"}`,
		`Thread link: ${threadUrl}`,
	].join("\n")

	const turns = messages
		.filter((m) => m.content?.trim())
		.map(
			(m) =>
				`${m.role === "user" ? "User" : "Assistant"}: ${stripHtml(m.content)}`,
		)

	const buildPrompt = (transcript: string[], omitted: boolean): string => {
		const lines = omitted ? [OMITTED_MARKER, ...transcript] : transcript
		return `${header}\n\nConversation so far:\n${lines.join("\n")}`
	}

	let kept = turns
	let prompt = buildPrompt(kept, false)
	// Drop oldest turns first; the header (MCP + thread reference) is never cut.
	while (prompt.length > CLAUDE_CODE_PROMPT_MAX && kept.length > 1) {
		kept = kept.slice(1)
		prompt = buildPrompt(kept, true)
	}
	prompt = prompt.slice(0, CLAUDE_CODE_PROMPT_MAX)

	return {
		deepLink: `claude-cli://open?q=${encodeURIComponent(prompt)}`,
		prompt,
	}
}
